export default "-- ClickBench Q24\nselect searchphrase\nfrom hits\nwhere searchphrase <> ''\norder by eventtime \nlimit 10;";